const CalendarLine = ({ width = 20, height = 20, color = 'currentColor', ...props }) => {
  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <path
        d="M17 3.21289H21C21.2652 3.21289 21.5196 3.31825 21.7071 3.50578C21.8946 3.69332 22 3.94767 22 4.21289V20.2129C22 20.4781 21.8946 20.7325 21.7071 20.92C21.5196 21.1075 21.2652 21.2129 21 21.2129H3C2.73478 21.2129 2.48043 21.1075 2.29289 20.92C2.10536 20.7325 2 20.4781 2 20.2129V4.21289C2 3.94767 2.10536 3.69332 2.29289 3.50578C2.48043 3.31825 2.73478 3.21289 3 3.21289H7V1.21289H9V3.21289H15V1.21289H17V3.21289ZM15 5.21289H9V7.21289H7V5.21289H4V9.21289H20V5.21289H17V7.21289H15V5.21289ZM20 11.2129H4V19.2129H20V11.2129Z"
        fill={color}
      />
    </svg>
  )
}

export default CalendarLine
